import { checkInGuestUrl } from "../constants/urls";
import { RestResponse } from "@/business/shared/commons/rest/RestResponse";
import { restClient } from "@/business/shared/commons/rest/restClient";
import { getEnvVariable } from "@/business/shared/commons/envUtils/getEnvVariable";
import { CheckInGuestRequest } from "../../domain/events";
import { DaccachErrorActions } from "@/business/shared/commons/DaccachError";

export const checkInGuestService = {
  async execute(
    token: string,
    checkInGuestRequest: CheckInGuestRequest
  ): Promise<void> {
    const url = getEnvVariable
      .execute("VUE_APP_DACCACH_URL")
      .concat(checkInGuestUrl);

    const headers = {
      "web-token": token,
      Accept: "application/json",
      "Content-Type": "application/json",
    };

    const response: RestResponse = await restClient().sendRequest(
      url,
      "POST",
      JSON.stringify(checkInGuestRequest),
      headers
    );

    if (!response.isSuccess) {
      const errorMessage =
        response.statusCode == 422
          ? DaccachErrorActions().extractFormError(response.content)
          : response.content;
      throw DaccachErrorActions().createError(errorMessage);
    }
  },
};
